import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import {Group, GroupInfo, HeaderInfo} from "../../../shared/models/group-portal-data.models";
@Component({
	selector: 'app-group-header',
	templateUrl: './group-header.component.html',
	styleUrls: ['./group-header.component.scss']
})

export class GroupHeaderComponent implements OnInit {
	@Input() headerInfo: HeaderInfo;
	@Input() errorExists: boolean;
	@Input() errorMessage: string;
	ngOnInit() { }
}
